//
// ReportViewerNLUManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var ReportViewerNLUManager = createModule("transport::ReportViewerNLUManager", ["transport::SubserviceManager"], EventDispatcher, [
    {
        DOMAIN_LOAD_STARTED: 60007,
        DOMAIN_LOAD_IN_PROGRESS: 60008,
        DOMAIN_LOAD_FAILED: 60009,
    },
    ,
    ,
    ,
    {
        interpretations: [1,1],
    },
    ,
    ,
]);
export default ReportViewerNLUManager;
